import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary-blue body fw-bold mb-2 d-flex align-items-center gap-2"
}


  import StationIcon from '@/assets/StationIcon.vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingHeader',
  props: {
    liheName: {
      type: String,
      required: true,
    },
    stationName: {
      type: String,
      required: true,
    },
    showStationHeader: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.liheName), 1),
    (__props.showStationHeader)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createVNode(StationIcon),
          _createTextVNode(" " + _toDisplayString(__props.stationName), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})